import {ServiceProviderRepository} from '../repository/ServiceProviderRepository';

export class GetServiceProviderStatsUseCase {
  constructor (private repo: ServiceProviderRepository) {}

  async execute (id: string): Promise<any> {
    return this.repo.getStats(id);
  }
}
